import * as React from 'react';
import { Input } from '@/shared/ui/input';
import { cn } from '@/lib/utils';

export interface DateInputProps
  extends Omit<React.ComponentProps<typeof Input>, 'type'> {
  /** When provided, end date cannot be before this (for start/end date pairs) */
  minFromStartDate?: string;
}

/**
 * Consistent date input with native calendar picker across the project.
 * Uses type="date" for browser-native calendar UX (same as Project Overview).
 */
const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>(
  ({ minFromStartDate, className, min, ...props }, ref) => {
    const computedMin = min ?? minFromStartDate;

    return (
      <Input
        ref={ref}
        type="date"
        min={computedMin}
        className={cn('bg-white', className)}
        autoComplete="off"
        data-form-type="other"
        data-lpignore="true"
        data-1p-ignore="true"
        {...props}
      />
    );
  }
);

DateInput.displayName = 'DateInput';

export { DateInput };
